const IsoPlayStoreLink = ({ isoLink, playStoreLink }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          color: "red",
          marginTop: "80px",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {playStoreLink && (
          <div style={{ cursor: "pointer" }}>
            <a href={playStoreLink} target="_blank" rel="noopener noreferrer">
              <img src="/gplay.png" alt="Get it on Google Play" />
            </a>
          </div>
        )}
        {isoLink && (
          <div style={{ marginLeft: "20px", cursor: "pointer" }}>
            <a href={isoLink} target="_blank" rel="noopener noreferrer">
              <img src="/appstore.png" alt="Download on the App Store" />
            </a>
          </div>
        )}
      </div>
    </>
  );
};
export default IsoPlayStoreLink;
